import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  ChangeDetectorRef,
} from "@angular/core";
import { AppMovilService } from "src/app/services/app-movil.service";
import {
  FormBuilder,
  FormGroup,
  FormControl,
  Validators,
  AbstractControl,
} from "@angular/forms";
import { Observable, Subscription, from } from "rxjs";
import {
  NgbModal,
  NgbModalRef,
  NgbModalOptions,
} from "@ng-bootstrap/ng-bootstrap";
import { LoaderService } from "src/app/services/loader.service";
import { DateUtils } from "src/app/shared/utils/date-utils";
import {
  filter,
  switchMap,
  take,
  concatMap,
  map,
  toArray,
  tap,
} from "rxjs/operators";
import { MapUtils } from "src/app/shared/utils/map-utils";
import { FacadeSesionService } from "src/app/services/facade-sesion.service";
import { GooglePolyline } from "src/app/models/google-polyline";
import { ElementoCatalogo } from "src/app/models/entities/elemento-catalogo";
import { RutaCatalogoEnum } from "src/app/shared/enums/ruta-catalogo.enum";
import { Estado } from "src/app/models/entities/estado";
import { CatalogoService } from "src/app/services/catalogo.service";
import { LevantamientoObra } from "src/app/models/entities/levantamiento-obra";
import { LevantamientoObraService } from "src/app/services/levantamiento-obra.service";
import { LevantamientoSeleccionadoDTO } from "src/app/models/dtos/levantamiento-seleccionado-dto";
import { ArchivoCoordenada } from "src/app/models/entities/archivo-coordenada";
import { Coordenada } from "src/app/models/entities/coordenada";
import { Segmento } from "src/app/models/entities/segmento";
import { CapaSegmentosDTO } from "src/app/models/dtos/capa-segmentos-dto";
import { Capa } from "src/app/models/entities/capa";
import { Usuario } from "src/app/models/entities/usuario";
import { UsuarioService } from "src/app/services/usuario.service";
import { SegmentoService } from "src/app/services/segmento.service";
import { CapaService } from "src/app/services/capa.service";
import { ArchivoCoordenadaService } from "src/app/services/archivo-coordenada.service";

@Component({
  selector: "busquedas-fotos-obra",
  templateUrl: "./busquedas-fotos-obra.component.html",
  styleUrls: ["./busquedas-fotos-obra.component.scss"],
})
export class BusquedasFotosObraComponent implements OnInit, OnDestroy {
  @ViewChild("galeria")
  public modal: any;
  public modalActivo: NgbModalRef;
  public modalOption: NgbModalOptions = {};

  public form: FormGroup;
  public fotos: any[];
  public filtroFotos: any[] = [];
  public filtroFotosCopia: any[] = [];
  public mostrarMensajeSinFotos: boolean = false;
  public suscripcionFotos: Subscription;
  public indice: number = 0;
  public panelWidth: number = 0;
  public panelHeight: number = 0;
  public fechaImagen: number = 0;
  public nombreCapaImagen: string = "";
  public nombreImagen: string = "";
  public descripcionImagen: string = "";

  public catDireccionesAdjuntas: ElementoCatalogo[] = null;
  public catEstados: Estado[] = [];
  public mostrarBotonGaleria: boolean = false;
  public catCapas: ElementoCatalogo[];
  public catSubElementos: ElementoCatalogo[];
  public catTipoLevantamiento: ElementoCatalogo[];
  public catTipoObra: ElementoCatalogo[];
  public catColores: ElementoCatalogo[];
  public tipoConsulta: string = "";
  public datosObra: LevantamientoSeleccionadoDTO;

  public mostraBotonGaleria: boolean = false;

  public anioActual = new Date().getFullYear();

  public readonly CAMINOS_RURALES: string = "0";
  public readonly CARRETERAS_FEDERALES: string = "1";
  public readonly CAPA_PROYECTO_PROCESO: string = "0";
  public readonly CAPA_PROYECTO_PLANEACION: string = "4";
  public readonly CAPA_META_ACTUAL: string = "1";
  public readonly CAPA_COMPLETADO: string = "2";
  public readonly CAPA_ESTRUCTURA: string = "5";

  public levantamientosObras: LevantamientoObra[];
  public suscripcionObras: Subscription;
  public map: any;

  public iconoMultimedia: any = {
    url: "../../../../../assets/img/iconos/icono-multimedia.png",
    scaledSize: {
      width: 25,
      height: 25,
    },
  };
  public iconoPuente: any = {
    url: "../../../../../assets/img/iconos/icono-puente.png",
    scaledSize: {
      width: 25,
      height: 25,
    },
  };
  public iconoCoordenada: any = {
    url: "../../../../../assets/img/iconos/coordenada-disponible.png",
    scaledSize: {
      width: 5,
      height: 5,
    },
  };

  constructor(
    private mapUtils: MapUtils,
    private loaderScreenService: LoaderService,
    private cd: ChangeDetectorRef,
    private ngbModalService: NgbModal,
    private formBuilder: FormBuilder,
    private facadeSesionService: FacadeSesionService,
    private catalogoService: CatalogoService,
    private levantamientoObraService: LevantamientoObraService,
    private usuarioService: UsuarioService,
    private segmentoService: SegmentoService,
    private capaService: CapaService,
    private archivoCoordenadaService: ArchivoCoordenadaService
  ) {}

  public ngOnInit(): void {
    this.facadeSesionService.breadcrumbService.actualizarBreadcrumbFuncionalidad(
      "Galería de fotos"
    );
    this.obtenerCatalogos();
    this.inicializarForm();
    this.inicializarFiltrosSelects();
    this.calcularTamanioPanelGaleria();
  }

  ngOnChanges() {
    if (this.map) {
      //Se valida que el mapa este pintado en pantalla para poder centrar las polylines
      this.mapUtils.centrarArregloDePolylines(
        this.map,
        this.crearArregloPolylines(this.datosObra.capasSegmentos)
      );
    }
    this.cd.detectChanges();
  }

  public calcularTamanioPanelGaleria() {
    this.panelWidth = window.innerWidth * 0.6;
    this.panelHeight = window.innerHeight * 0.65;
  }

  public inicializarForm(): void {
    this.form = this.formBuilder.group({
      keyDireccionAdjunta: new FormControl("-1", [
        Validators.required,
        this.validateId,
      ]),
      keyCatEstado: new FormControl("-1", [
        Validators.required,
        this.validateId,
      ]),
      keyLevantamientoObra: new FormControl("-1", [
        Validators.required,
        this.validateId,
      ]),
    });
  }

  public inicializarFiltrosSelects() {
    this.form.get("keyDireccionAdjunta").valueChanges.subscribe(() => {
      this.form.controls["keyCatEstado"].setValue("-1");
    });

    this.form
      .get("keyCatEstado")
      .valueChanges.pipe(
        tap(() => {
          this.form.get("keyLevantamientoObra").setValue("-1");
        }),
        filter((keyCatEstado: string) => keyCatEstado !== "-1"),
        switchMap((keyCatEstado: string) =>
          this.levantamientoObraService.findAprobados().pipe(
            take(1),
            map((levsObras: LevantamientoObra[]) =>
              levsObras.filter(
                (levObra: LevantamientoObra) =>
                  levObra.keyCatEstado === keyCatEstado &&
                  levObra.keyCatDireccionAdjunta ===
                    this.form.controls["keyDireccionAdjunta"].value
              )
            )
          )
        )
      )
      .subscribe((levantamientosObras: LevantamientoObra[]) => {
        this.levantamientosObras = levantamientosObras;
      });

    this.form
      .get("keyLevantamientoObra")
      .valueChanges.pipe(
        tap((keyLevantamientoObra: string) => {
          if (keyLevantamientoObra === "-1") {
            // Se debe limpiar el objeto de levantmaientosObra
            this.mostraBotonGaleria = false;
          } else {
            this.loaderScreenService.activarLoaderScreen();
          }
        }),
        filter((keyLevantamientoObra: string) => keyLevantamientoObra !== "-1"),
        map((keyLevObra: string) =>
          this.levantamientosObras.find(
            (levObra: LevantamientoObra) => levObra.key === keyLevObra
          )
        ),
        concatMap((levObra: LevantamientoObra) =>
          this.usuarioService.findByKey(levObra.keyUsuarioLevantamiento).pipe(
            take(1),
            concatMap((usuarioLevantamiento: Usuario) =>
              this.usuarioService.findByKey(levObra.keyUsuarioAprobacion).pipe(
                take(1),
                map((usuarioAprobo: Usuario) => {
                  let datosObra: LevantamientoSeleccionadoDTO = {};
                  datosObra.direccionAdjunta = this.catDireccionesAdjuntas.find(
                    (direccionAdjunta: ElementoCatalogo) =>
                      direccionAdjunta.key === levObra.keyCatDireccionAdjunta
                  );
                  datosObra.tipoObra = this.catTipoObra.find(
                    (tipoObra: ElementoCatalogo) =>
                      tipoObra.key === levObra.keyCatTipoObra
                  );
                  datosObra.estado = this.catEstados.find(
                    (estado: Estado) => estado.key === levObra.keyCatEstado
                  );
                  datosObra.tipoLevantamiento = this.catTipoLevantamiento.find(
                    (tipoLevantamiento: ElementoCatalogo) =>
                      tipoLevantamiento.key === levObra.keyCatTipoLevantamiento
                  );
                  datosObra.usuarioAprobo = usuarioAprobo;
                  datosObra.usuarioLevantamiento = usuarioLevantamiento;
                  datosObra.levObra = levObra;
                  return datosObra;
                }),
                concatMap((levSelDTO: LevantamientoSeleccionadoDTO) =>
                  this.capaService
                    .findByKeyLevantamientoObra(levSelDTO.levObra.key)
                    .pipe(
                      take(1),
                      concatMap((capas: Capa[]) =>
                        from(capas).pipe(
                          concatMap((capa: Capa) =>
                            this.segmentoService.findByKeyCapa(capa.key).pipe(
                              take(1),
                              map((segmentos: Segmento[]) => {
                                let capaSegmentos: CapaSegmentosDTO = {
                                  capa,
                                  segmentos: segmentos.map(
                                    (segmento: Segmento) => ({
                                      ...segmento,
                                      nombreColor: this.catColores.find(
                                        (e: ElementoCatalogo) =>
                                          e.key === segmento.keyCatColor
                                      ).nombre,
                                    })
                                  ),
                                  nombreCapa: this.catCapas.find(
                                    (e: ElementoCatalogo) =>
                                      e.key === capa.keyCatCapa
                                  ).nombre,
                                };
                                return capaSegmentos;
                              })
                            )
                          ),
                          toArray()
                        )
                      ),
                      map(
                        (capasSegmentos: CapaSegmentosDTO[]) =>
                          ({
                            ...levSelDTO,
                            capasSegmentos,
                          } as LevantamientoSeleccionadoDTO)
                      )
                    )
                )
              )
            )
          )
        ),
        concatMap((datosObraSeleccionada: LevantamientoSeleccionadoDTO) =>
          this.archivoCoordenadaService
            .findByKeyLevantamientoObra(datosObraSeleccionada.levObra.key)
            .pipe(
              take(1),
              map((archivos: ArchivoCoordenada[]) => {
                this.filtroFotos = [];
                this.filtroFotosCopia = [];
                datosObraSeleccionada.capasSegmentos.forEach(
                  (capaSegmentos: CapaSegmentosDTO) => {
                    capaSegmentos.segmentos.forEach((segmento: Segmento) => {
                      segmento.coordenadas.forEach(
                        (coordenada: Coordenada, indice: number) => {
                          let archivosEncontrados: ArchivoCoordenada[] = archivos.filter(
                            (a: ArchivoCoordenada) =>
                              a.keySegmento === segmento.key &&
                              a.keyCoordenada === indice.toString()
                          );
                          if (archivosEncontrados.length > 0) {
                            coordenada.archivos = archivosEncontrados;
                          } else {
                            coordenada.archivos = [];
                          }
                        }
                      );
                    });
                    capaSegmentos.mostrarCapa = true;
                    switch (capaSegmentos.capa.keyCatCapa) {
                      case this.CAPA_PROYECTO_PROCESO:
                        capaSegmentos.zIndex = 10;
                        break;
                      case this.CAPA_PROYECTO_PLANEACION:
                        capaSegmentos.zIndex = 10;
                        break;
                      case this.CAPA_META_ACTUAL:
                        capaSegmentos.zIndex = 20;
                        break;
                      case this.CAPA_COMPLETADO:
                        capaSegmentos.zIndex = 30;
                        break;
                      case this.CAPA_ESTRUCTURA:
                        capaSegmentos.zIndex = 40;
                        break;
                    }
                  }
                );
                return datosObraSeleccionada;
              })
            )
        )
      )
      .subscribe((datosObraSeleccionada: LevantamientoSeleccionadoDTO) => {
        this.datosObra = datosObraSeleccionada;
        for (
          let index = 0;
          index < datosObraSeleccionada.capasSegmentos.length;
          index++
        ) {
          for (
            let indice = 0;
            indice <
            datosObraSeleccionada.capasSegmentos[index].segmentos.length;
            indice++
          ) {
            for (
              let i = 0;
              i <
              datosObraSeleccionada.capasSegmentos[index].segmentos[indice]
                .coordenadas.length;
              i++
            ) {
              for (
                let j = 0;
                j <
                datosObraSeleccionada.capasSegmentos[index].segmentos[indice]
                  .coordenadas[i].archivos.length;
                j++
              ) {
                if (
                  datosObraSeleccionada.capasSegmentos[index].segmentos[indice]
                    .coordenadas[i].archivos[j].urlDescarga
                ) {
                  let foto = {
                    source:
                      datosObraSeleccionada.capasSegmentos[index].segmentos[
                        indice
                      ].coordenadas[i].archivos[j].urlDescarga,
                    alt:
                      datosObraSeleccionada.capasSegmentos[index].segmentos[
                        indice
                      ].coordenadas[i].archivos[j].nombre,
                    title:
                      datosObraSeleccionada.capasSegmentos[index].segmentos[
                        indice
                      ].coordenadas[i].archivos[j].descripcion,
                    nombreCapa: this.obtenerNombreCapaByKey(
                      datosObraSeleccionada.capasSegmentos[index].segmentos[
                        indice
                      ].coordenadas[i].archivos[j].keyCatCapa
                    ),
                    fechaCreacion:
                      datosObraSeleccionada.capasSegmentos[index].segmentos[
                        indice
                      ].coordenadas[i].archivos[j].fechaCreacion,
                    lat:
                      datosObraSeleccionada.capasSegmentos[index].segmentos[
                        indice
                      ].coordenadas[i].latitud,
                    lng:
                      datosObraSeleccionada.capasSegmentos[index].segmentos[
                        indice
                      ].coordenadas[i].longitud,
                    tipo:
                      datosObraSeleccionada.capasSegmentos[index].segmentos[
                        indice
                      ].coordenadas[i].archivos[j].tipo,
                  };
                  this.filtroFotos.push(foto);
                }
              }
            }
          }
        }
        this.mostraBotonGaleria = true;
        this.loaderScreenService.desactivarLoaderScreen();
        if (this.filtroFotos.length > 0) {
          this.filtroFotosCopia = this.filtroFotos;
          this.fechaImagen = this.filtroFotos[0].fechaCreacion;
          this.nombreCapaImagen = this.filtroFotos[0].nombreCapa;
          this.filtroFotos.sort(function (a, b) {
            let dateA: any = new Date(a.fechaCreacion),
              dateB: any = new Date(b.fechaCreacion);
            return dateA - dateB;
          });
        } else {
          console.log("No contiene fotos");
        }
      });
  }

  public obtenerNombreCapaByKey(keyCapa: number): string {
    console.log("hola", keyCapa);
    //return this.catCapas.find((capa: any) => capa.key === keyCapa).nombre;
    return "Galeria";
  }

  public async obtenerCatalogos(): Promise<any> {
    this.catDireccionesAdjuntas = await this.catalogoService
      .obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.DIRECCIONES_ADJUNTAS)
      .pipe(take(1))
      .toPromise();
    this.catEstados = await this.catalogoService
      .obtenerCatalogo<Estado>(RutaCatalogoEnum.ESTADOS)
      .pipe(take(1))
      .toPromise();
    // this.catSubElementos = await this.catalogoService.obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.SUB_ELEMENTOS).pipe(take(1)).toPromise();
    this.catColores = await this.catalogoService
      .obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.COLORES)
      .pipe(take(1))
      .toPromise();
    this.catCapas = await this.catalogoService
      .obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.CAPAS)
      .pipe(take(1))
      .toPromise();
    this.catTipoObra = await this.catalogoService
      .obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.TIPOS_OBRAS)
      .pipe(take(1))
      .toPromise();
    this.catTipoLevantamiento = await this.catalogoService
      .obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.TIPOS_LEVANTAMIENTOS)
      .pipe(take(1))
      .toPromise();
  }

  private validateId(control: AbstractControl) {
    return control.value === "-1" ? { error: "El campo es requerido" } : null;
  }

  public abrirGaleriaFotos() {
    // this.loaderScreenService.activarLoaderScreen();
    this.modalActivo = this.ngbModalService.open(this.modal, {
      size: "lg",
      centered: true,
      windowClass: "modal-galeria",
      backdrop: "static",
      keyboard: false,
    });
  }

  public seleccionarCapa(event: any, nombreCapaSeleccionada: any) {
    let nombreCapa = this.catCapas.find(
      (capa: any) => capa.key === nombreCapaSeleccionada
    ).nombre;
    if (event === true) {
      this.filtroFotos = this.filtroFotos.concat(
        this.filtroFotosCopia.filter((f) => f.nombreCapa === nombreCapa)
      );
      this.fechaImagen = this.filtroFotos[0].fechaCreacion;
      this.nombreCapaImagen = this.filtroFotos[0].nombreCapa;
    } else {
      this.filtroFotos = this.filtroFotos.filter(
        (f) => f.nombreCapa !== nombreCapa
      );
      // this.fechaImagen = this.filtroFotos[0].fechaCreacion;
      // this.nombreCapaImagen = this.filtroFotos[0].nombreCapa;
    }
    this.indice = 0;
  }

  public obtenerNombreCapa(nombreCapa: string): string {
    if (nombreCapa === "Avance") return "En proceso de modernización";
    if (nombreCapa === "AvanceFull") return "Modernizado";
    if (nombreCapa === "Estructura") return "Estructura";
    if (nombreCapa === "Problema") return "Problemática";
    if (nombreCapa === "proyecto") return "Por Modernizar";
  }

  public cambioImagen(event: any) {
    this.indice = event.index;
    this.fechaImagen = this.filtroFotos[this.indice].fechaCreacion;
    this.nombreCapaImagen = this.filtroFotos[this.indice].nombreCapa;
    this.nombreImagen = this.filtroFotos[this.indice].title;
  }

  public centrarMapa() {
    this.mapUtils.centrarArregloDePolylines(
      this.map,
      this.crearArregloPolylines(this.datosObra.capasSegmentos)
    );
  }

  public mapReady(event: any): void {
    this.map = event;
    this.mapUtils.centrarArregloDePolylines(
      this.map,
      this.crearArregloPolylines(this.datosObra.capasSegmentos)
    );
  }

  public crearArregloPolylines(capasSegmentos: CapaSegmentosDTO[]): any {
    let coordenadas: Array<Coordenada[]> = new Array<Coordenada[]>();
    capasSegmentos.forEach((capaSegmento) => {
      capaSegmento.segmentos.forEach((segmento: Segmento) => {
        coordenadas.push(segmento.coordenadas);
      });
    });
    return coordenadas.map((coordenadas: Coordenada[]) =>
      this.crearPolyline(coordenadas)
    );
  }

  public crearPolyline(points: Coordenada[]): any {
    return {
      googlePolylinePoints: points.map((p) => ({
        lat: p.latitud,
        lng: p.longitud,
      })),
    };
  }

  public cambiarCapaFederales(nombreCapa: string) {
    if (this.datosObra.direccionAdjunta.key === this.CARRETERAS_FEDERALES) {
      if (nombreCapa === "Completado") {
        return "Modernizado";
      } else if (nombreCapa === "Meta actual") {
        // return `Programado ${this.anioActual}`;
        return "Programado";
      } else {
        return nombreCapa;
      }
    } else {
      return nombreCapa;
    }
  }

  public ngOnDestroy(): void {
    if (this.suscripcionObras) {
      this.suscripcionObras.unsubscribe();
    }
  }
}
